import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  public searchTerms: Map<string, string> = new Map();
  
  constructor() { }

  setSearchTerm(page: string, term: string) {
    this.searchTerms.set(page, term);
  }

  getSearchTerm(page: string): string {
    return this.searchTerms.get(page) ?? '';
  }

}
